import React, { useState, useEffect } from 'react';
import { object, array } from 'prop-types';
import {withRouter} from 'react-router-dom';

import {connect} from 'react-redux';
import {orderBy} from 'lodash';

import NoTechniciansPage from './NoTechniciansPage';
import TechniciansList from './TechniciansList';
import CreateTechnician from './CreateTechnician';
import EditTechnician from './EditTechnician';
import LinksTableAndSearch from './LinksTableAndSearch';
import CreateLinkModal from '../Modals/CreateLinkModal';
import DeleteLinkModal from '../Modals/DeleteLinkModal';

import * as ArchitectActions from '../../actions/architectActions';
import { fetchErpAgents } from '../../actions/erpAgentActions';

import classes from './TechnicianPage.module.css';
import DeleteTechnicianModal from '../Modals/DeleteTechnicianModal';

const TechnicianPage = ({
    companyInfo,
    selectedTechnician,
    setSelectedTechnician,
    order,
    links,
    techniciansList,
    fetchErpAgents,
    fetchErpAgentConfigurations,
    fetchErpLinks,
    fetchTechniciansList,
    ...props
}) => {
    const [createPanelOpen, setCreatePanelOpen] = useState(false);
    const [createLinkModalOpen, setCreateLinkModalOpen] = useState(false);
    const [deleteLinkModalOpen, setDeleteLinkModalOpen] = useState(false);
    const [deleteTechnicianModalOpen, setDeleteTechnicianModalOpen] = useState(false);

    useEffect(() => {
        async function init() {
            setSelectedTechnician(null);
            await fetchTechniciansList();
        }

        init();
    }, [companyInfo.companyId]);

    const getLinks = async () => {
        await fetchErpAgents();
        await fetchErpAgentConfigurations();
        await fetchErpLinks('technician', {entityId: selectedTechnician.id});
    };

    const handleSort = (data, property) => {
        return () => {
            data.reorderItems(property);
        };
    };

    const openCreatePanel = () => {
        setSelectedTechnician(null);
        setCreatePanelOpen(true);
    };

    const closeCreatePanel = () => {
        setCreatePanelOpen(false);
    };

    const closeEditPanel = () => {
        setSelectedTechnician(null);
    };

    const handleToggleCreateLinkModal = toggleState => {
        setCreateLinkModalOpen(toggleState);
    };

    const handleToggleDeleteLinkModal = toggleState => {
        setDeleteLinkModalOpen(toggleState);
    };

    const handleToggleDeleteTechnicianModal = toggleState => {
        setDeleteTechnicianModalOpen(toggleState);
    };

    return (
        <div className={classes.TechnicianPage}>
            <TechniciansList
                order={order}
                orderBy={orderBy}
                handleSort={property => handleSort(props, property)}
                openCreatePanel={openCreatePanel}
                onToggleCreateTechnicianModal={handleToggleDeleteTechnicianModal}
                closeCreatePanel={closeCreatePanel}
                techniciansList={techniciansList}
            />
            {selectedTechnician ?
                <div className={classes.TechnicianInfo}>
                    <EditTechnician
                        closeEditPanel={closeEditPanel}
                    />
                    {process.env.erpAgentEnabled &&
                        <LinksTableAndSearch
                            className={classes.LinksTable}
                            order={order}
                            orderBy={orderBy}
                            handleSort={handleSort}
                            onToggleCreateLinkModal={handleToggleCreateLinkModal}
                            onToggleDeleteLinkModal={handleToggleDeleteLinkModal}
                            selectedNode={selectedTechnician}
                            links={links}
                            getLinks={getLinks}
                        />
                    }
                </div>
                : createPanelOpen ?
                    <div className={classes.TechnicianInfo}>
                        <CreateTechnician
                            closeCreatePanel={closeCreatePanel}
                        />
                    </div>
                    :
                    <div className={classes.NoTechniciansPanel}>
                        <NoTechniciansPage />
                    </div>
            }
            <CreateLinkModal
                open={createLinkModalOpen}
                close={() => handleToggleCreateLinkModal(false)}
                title="New ERP Link"
                linkType={'technician'}
            />
            <DeleteLinkModal
                open={deleteLinkModalOpen}
                close={() => handleToggleDeleteLinkModal(false)}
                title="Delete Link"
            />
            <DeleteTechnicianModal
                open={deleteTechnicianModalOpen}
                close={() => handleToggleDeleteTechnicianModal(false)}
                title="Delete Technician"
            />
        </div>
    );
};

TechnicianPage.defaultProps = {
    selectedTechnician: null,
    techniciansList:    []
};

TechnicianPage.propTypes = {
    selectedTechnician: object,
    techniciansList:    array
};

const mapStateToProps = state => {
    const {
        selectedTechnician,
        order,
        links,
        techniciansList,
        orderBy: orderByKey
    } = state.architect;

    return {
        companyInfo:     state.companyInfo,
        currentScopes:   state.core.currentScopes,
        order,
        selectedTechnician,
        techniciansList: orderBy(techniciansList, [orderByKey], order),
        orderBy:         orderByKey,
        links:           orderBy(links, [orderByKey], order)
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    fetchErpAgents
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TechnicianPage)
);
